import { GetterTree } from "vuex";
import * as types from "@/store/constants/types";
import { getQueryString } from "@/api/http/utils/apiHelpers";
const Getters: GetterTree<any, any> = {
  [types.GETTER_COOKIE_BY_USER_ID](state, getters, rootState) {
    return (payload: number) => {
      typeof payload === "string"
        ? (payload = parseInt(payload))
        : (payload = payload);
      const findUser = state.cookieData.find((item: any) => {
        return item.userId === payload;
      });
      return findUser === undefined ? null : findUser.cookie;
    };
  },
  [types.GETTER_MASTER_COOKIE](state, getters, rootState) {
    return state.cookieData.length === 0 ? null : state.cookieData[0].cookie;
  },
  [types.GETTER_CROS_TOKEN_BY_USER_ID](state, getters, rootState) {
    return (payload: number) => {
      typeof payload === "string"
        ? (payload = parseInt(payload))
        : (payload = payload);
      const findUser = state.cookieData.find((item: any) => {
        return item.userId === payload;
      });
      if (findUser === undefined) {
        return null;
      } else {
        const cookieString = findUser.cookie;
        return cookieString.csrftoken ? cookieString.csrftoken : null;
      }
    };
  }
};

export default Getters;
